import { type AccountEmail, accountEmail } from "@pima/utils";

/**
 * A form address that cannot hold an account. Raised before any request is
 * sent, so the API's decode refusal is never reached from a form; the tag lets
 * screens show their invalid-email message for it.
 */
export class InvalidEmailAddress extends Error {
  readonly _tag = "InvalidUserInput";
  readonly field = "email";

  constructor() {
    super("Invalid email address");
  }
}

/** The address a form holds, as the account key the API takes. */
export const toAccountEmail = (input: string): AccountEmail => {
  const key = accountEmail(input);
  if (key === null) throw new InvalidEmailAddress();
  return key;
};
